import React, { useState } from 'react';
import './App.css';
import { Container, Switch } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { useTheme, ThemeProvider, createTheme } from '@mui/material/styles';

import DarkModeSwitch from './DarkModeSwitch';
import SearchBar from './search/SearchBar';
import Overlap from './overlap/Overlap';

const App = () => {
    const [etfData, setEtfData] = useState({});
    const [toggleDark, settoggleDark] = useState(false);

    const myCallback = (data) => {
        setEtfData(data);
    }

    const myTheme = createTheme({
        palette: {
            mode: toggleDark ? 'dark' : 'light',
        }
    });

    return (
        <ThemeProvider theme={myTheme}>
            <CssBaseline />
            <Container sx={{ p: 5 }} align="center">
                <DarkModeSwitch toggleDark={toggleDark}
                    settoggleDark={settoggleDark} />
                <SearchBar parentCallback={myCallback} />
                <Overlap etfData={etfData} />
            </Container>
        </ThemeProvider>
    );
}

export default App;
